// extracted by mini-css-extract-plugin
export var logo = "_kf-2";
export var logoWrapper = "_kf-1";
export var strip = "_kf-0";